import {CopilotCodeReviewFindings} from '@github-ui/copilot-code-review-findings'
import {useRouteQuery, useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {PageLayout} from '@primer/react'
import {Suspense} from 'react'
import {PullRequestStoreProvider} from '../stores/PullRequestStore'
import {pullRequestsFindingsRoute} from './findings-route'

export const FindingsEntrypoint = () => (
  <PageLayout.Content as="div" padding="normal" width="full">
    <ErrorBoundary boundaryName="FindingsEntrypoint" fallback={null}>
      <Suspense fallback={null}>
        <FindingsWithStore />
      </Suspense>
    </ErrorBoundary>
  </PageLayout.Content>
)

export const FindingsWithStore = () => {
  const {data: findings} = useRouteQuery(pullRequestsFindingsRoute, 'mainQuery')
  const {data: baseComparisonInfo} = useSuspenseRouteQuery(pullRequestsFindingsRoute, 'base_comparison_info')

  return (
    <PullRequestStoreProvider initData={baseComparisonInfo}>
      <CopilotCodeReviewFindings {...findings} />
    </PullRequestStoreProvider>
  )
}
